import api from '@/api/index.js'

const account_emv_clearings = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_EMV_CLEARINGS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_EMV_CLEARINGS: (state, data) => {
      state.data = data
      state.loading = false;
    },
    SET_ACCOUNT_EMV_CLEARINGS_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    },
    SET_ACCOUNT_EMV_CLEARINGS_UPDATED: (state, u) => {
      state.data = state.data.filter(item => {
        if (item.id == u.id) {
          Object.assign(item, u);
        }
        return item
      });
    },
  },

  actions: {
    LoadAccountEmvClearings({commit}, id) {
      commit('SET_ACCOUNT_EMV_CLEARINGS_LOADING', true)
      return api.get(`accounts/${id}/emv-clearings?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_EMV_CLEARINGS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_EMV_CLEARINGS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default account_emv_clearings
